export interface NormalizedMetrics {
  views: number;
  likes: number;
  comments: number;
  shares: number;
}

export type MetricSortKey = keyof NormalizedMetrics;

export type SortKey = 'date' | MetricSortKey;

export interface SortConfig {
  key: SortKey;
  direction: 'asc' | 'desc';
}

export const ALL_ACCOUNTS_ID = "all";
